/* eslint-disable no-undef */

import React, { PureComponent } from 'react'
import { Box } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles/index'
import parse from 'html-react-parser'
import { Typography } from '@material-ui/core'
import HeaderImage from './HeaderImage'

const styles = theme => ({
    root: {},
    logoWrapper: {
        marginTop: theme.spacing(0.125),
        maxWidth: 300,
        margin: 'auto',
        lineHeight: 0
    },
    logo: {
        maxWidth: '100%'
    },
    contentWrapper: {
        maxWidth: theme.containerWidthCenter + 'px',
        width: '100%',
        margin: 'auto',
        padding: theme.spacing(4, 6.25, 4, 6.25),
        marginTop: theme?.headerMarginTop && theme?.headerMarginTop + 'px',
        [theme.breakpoints.down(600)]: {
            padding: theme.spacing(2, 3),
            marginTop: theme?.headerMarginTop && theme?.headerMarginTop / 2 + 'px'
        }
    },
    title: {
        margin: 0,
        paddingTop: '0px!important',
        paddingBottom: '0px!important',
        textTransform: theme.title.textTransform,
        marginTop: theme.spacing(1) + 'px!important',
        marginBottom: theme.spacing(1) + 'px!important',
        [theme.breakpoints.down(600)]: {
            fontSize: '1.3rem!important',
            marginTop: theme.spacing(1) + 'px!important',
            marginBottom: theme.spacing(1) + 'px!important'
        },
        color: theme.header?.color && theme.header.color + '!important',
        //textTransform: 'uppercase',
        textShadow: 'none!important'
    },
    description: {
        color: 'rgba(0, 0, 0, 0.61)!important',
        fontSize: '0.98rem!important',
        textAlign: 'center!important',
        marginBottom: theme.spacing(0.25),
        [theme.breakpoints.down(600)]: {
            fontSize: '0.9rem!important',
            marginBottom: theme.spacing(0.75)
        }
    },
    headerImageWrapper: {
        maxWidth: 1320,
        margin: 'auto',
        lineHeight: 0,
        textAlign: 'center'
    },
    headerImage: {
        maxWidth: '100%'
    },
    hideOnMobile: {
        [theme.breakpoints.down(1280)]: {
            display: 'none'
        }
    },
    hideOnDesktop: {
        [theme.breakpoints.up(1280)]: {
            display: 'none'
        }
    },
    forceVisible: {
        display: 'block!important'
    }
})

class QuestionPageExclusiveHeader extends PureComponent {
    state = {
        showFullDescription: false
    }

    handleShowFullDescription = () => {
        this.setState({ showFullDescription: true })
    }

    render() {
        const { showFullDescription } = this.state
        const { classes, theme, layout } = this.props

        return (
            <div className={classes.root + ' ' + (layout === 'premium-exclusive' ? classes.hideOnDesktop : '')}>
                {theme?.logo && (
                    <Box className={classes.logoWrapper + ' logo-wrapper'}>
                        <img className={classes.logo} src={theme.logo} />
                    </Box>
                )}
                {theme?.headerImage && (
                    <div className={classes.headerImageWrapper}>
                        <img className={classes.headerImage} src={theme.headerImage} />
                    </div>
                )}
                {theme && (theme.themeHeader || theme.themeDescription) && layout !== 'premium-exclusive' && (
                    <Box className={classes.contentWrapper}>
                        {theme.themeHeader && (
                            <Typography component="h4" variant={'h3'} align="center" className={classes.title}>
                                {parse(theme.themeHeader)}
                            </Typography>
                        )}
                        {theme.themeDescription && (
                            <>
                                {!showFullDescription && theme.themeDescriptionMobile && (
                                    <div className={classes.hideOnDesktop}>
                                        <Typography
                                            component="div"
                                            variant="body1"
                                            align="center"
                                            color="textSecondary"
                                            className={classes.description}
                                        >
                                            {parse(theme.themeDescriptionMobile)} <span onClick={this.handleShowFullDescription}>Lue lisää »</span>
                                        </Typography>
                                    </div>
                                )}
                                <div
                                    className={
                                        classes.hideOnMobile +
                                        ' ' +
                                        (showFullDescription || !theme.themeDescriptionMobile ? classes.forceVisible : '')
                                    }
                                >
                                    <Typography component="div" variant="body1" align="center" color="textSecondary" className={classes.description}>
                                        {parse(theme.themeDescription)}
                                    </Typography>
                                </div>
                            </>
                        )}
                    </Box>
                )}
            </div>
        )
    }
}

export default withStyles(styles)(QuestionPageExclusiveHeader)
